"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FeatureWrap = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
exports.FeatureWrap = styled_components_1.default.div `
  display: flex;
  flex-direction: column;
  padding: 12px;
  gap: 4px;
  border-radius: 18px;
  background-color: white;
  position: relative;
  box-sizing: border-box;
  width: min-content;

  & > a,
  .landing-feature-unfold {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;

    svg {
      height: 8px;
    }
  }

  .landing-feature-play {
    cursor: pointer;
  }

  .landing-feature-play-disabled {
    cursor: none;
    pointer-events: none;
  }

  div.landing-feature-line {
    display: flex;
    gap: 16px;
    align-items: center;
    width: fit-content;
    justify-content: flex-start;

    &.frst svg {
      width: 58px;
      height: 62px;
    }

    &.scnd svg {
      width: 58px;
      height: 31px;
    }

    span {
      font-family: Inter, sans-serif;
      font-size: 16px;
      line-height: 19px;
      text-wrap: wrap;
    }

    span.landing-feature-title {
      font-weight: 700;
      color: #7b4ef8;
    }

    span.landing-feature-text {
      font-weight: 500;
      color: #333333;
      text-wrap: nowrap;
    }

    span.landing-feature-title-absolute {
      position: absolute;
      right: 18px;
      top: 50%;
      transform: translateY(-50%);
    }
  }

  @media screen and (min-width: 768px) {
    padding: 20px 24px;
    gap: 8px;

    div.landing-feature-line {
      span {
        font-size: 24px;
        line-height: 29px;
      }

      span.landing-feature-text {
        font-size: 16px;
        line-height: 19px;
      }

      span.landing-feature-title-absolute {
        right: 24px;
      }
    }
  }

  @media screen and (min-width: 1300px) {
    padding: 20px 35px;
    gap: 15px;

    & > a svg,
    .landing-feature-unfold svg {
      height: 16px;
    }

    div.landing-feature-line {
      gap: 30px;

      &.frst svg {
        width: 110px;
        height: 120px;
      }

      &.scnd svg {
        width: 110px;
        height: 60px;
      }

      span {
        font-size: 27px;
        line-height: 33px;
      }

      span.landing-feature-text {
        font-size: 27px;
        line-height: 33px;
      }

      span.landing-feature-title-absolute {
        right: 35px;
      }
    }
  }

  @media screen and (min-width: 1690px) {
    padding: 40px 45px 40px 45px;
    gap: 20px;
    border-radius: 35px;

    div.landing-feature-line {
      display: flex;
      gap: 30px;
      align-items: center;
      width: fit-content;
      justify-content: flex-start;

      span {
        font-family: Inter, sans-serif;
        text-align: left;
        font-size: 36px;
        line-height: 44px;
      }

      span.landing-feature-title {
        font-weight: 700;
        color: #7b4ef8;
      }

      span.landing-feature-text {
        font-weight: 500;
        color: #333333;
      }
    }
  }
`;
